import React, { useCallback, useMemo } from 'react';
import { Box, FlatButton, getFullnameAbbr, OptionKey, Text } from '@common-fe/common-fe';
import { capitalize } from 'lodash';
import styled from 'styled-components';

import { REGEXPS } from '@/common';
import ROUTES from '@/common/routes';
import { useHistory } from '@/modules/core/hooks';
import currentTheme from '@/styles/theme';

interface Props {
  fullName: string;
  isMe?: boolean;
  relationshipType?: string;
  userId?: string;
  id: string;
  index?: number;
  onHover?: () => void;
  onBlur?: () => void;
  disabled?: boolean;
  defaultHealthPlanYearId?: OptionKey;
}

const Wrapper = styled(Box)`
  &:hover {
    background-color: ${({ theme }) => theme.colors.accentContainer};
  }
`;

export const DEPENDERS_COLORS = [
  currentTheme.colors.subgroup,
  currentTheme.colors.employee,
  currentTheme.colors.subsidiary,
  currentTheme.colors.distributor,
  currentTheme.colors.partner,
  currentTheme.colors.dependent,
  currentTheme.colors.noAssignee,
];
// this component is not the same as EmployerLogo from  the flex list component.
const SpendTrackerUser: React.FC<Props> = ({
  id,
  fullName,
  isMe,
  relationshipType,
  index,
  onBlur,
  onHover,
  disabled,
  defaultHealthPlanYearId,
}) => {
  const history = useHistory();
  const handleOpen = useCallback(() => {
    if (id && !disabled) {
      history.push(ROUTES.SPENDS_BY_ID(id, defaultHealthPlanYearId as string));
    }
  }, [id, disabled, history, defaultHealthPlanYearId]);

  const abbr = useMemo(() => getFullnameAbbr(fullName), [fullName]);
  return (
    <FlatButton
      onMouseEnter={onHover}
      onMouseLeave={onBlur}
      data-testid={`spend-tracker_user-${id}`}
      onClick={handleOpen}
      style={{
        pointerEvents: disabled ? 'none' : 'auto',
      }}
    >
      <Wrapper pad={{ vertical: 'xs', horizontal: 's' }} direction="row" round="l" align="center">
        <Box
          width="32px"
          height="32px"
          align="center"
          round="50%"
          justify="center"
          background={DEPENDERS_COLORS[(index ?? 0) % DEPENDERS_COLORS.length]}
        >
          <Text color="iconOnColor" weight={700}>
            {abbr}
          </Text>
        </Box>
        <Text margin={{ left: 'xs' }} size="medium" weight={700}>
          {`${fullName} `}
          <Text color="textDisabled">({capitalize(relationshipType).replace(REGEXPS.DASH_SYMBOL, ' ')})</Text>
        </Text>
      </Wrapper>
    </FlatButton>
  );
};

export default SpendTrackerUser;
